import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material";
import { moveItemInArray } from "@angular/cdk/drag-drop";
import { Router } from "@angular/router";
import { ResizedEvent } from "angular-resize-event";
import {
  SearchFilter,
  IFilterResponse,
} from "src/app/infrastructure/iFilter-component";
import { MedicalAppointmentCancel } from "src/app/model/medical-appointment-cancel";
import { ReservationInfo, Reservation } from "src/app/model/reservation";
import { ReservationSearchItem } from "src/app/model/reservation-search-item";
import { ConfirmDialogService } from "src/app/services/confirm-dialog.service";
import { MenuService } from "src/app/services/menu.service";
import { NotificationToastService } from "src/app/services/notification-toast.service";
import { ReservationService } from "src/app/services/reservation.service";
import { ReservationRescheduleWizardService } from "src/app/services/wizard/reservation/reservation-reschedule.wizard.service";
import { PagerControlComponent } from "../../controls/pager/pager-control.component";
import { SearchCompleteFilterComponent } from "../../controls/search-complete-filter/search-complete-filter.component";
import { LogViewDialogComponent } from "../../dialogs/log-view/log-view-dialog.component";
import { MedicalAppointmenObservationDialogComponent } from "../../dialogs/medical-appointment-observation/medical-appointment-observation-dialog.component";
import { MedicalAppointmentAuditingFilterComponent } from "../medical-appointment-auditing-filter/medical-appointment-auditing-filter.component";
import {
  MedicalAppointmentAudintingSearchItem,
  MedicalAppointmentAudintingType,
} from "src/app/model/medical-appointment-auditing/medical-appointment-auditing-search-item";
import { MedicalAppointmentAuditingService } from "src/app/services/medical-appointment-auditing/medical-appointment-auditing.service";
import { MedicalAppointmentAuditingControlDialogComponent } from "../medical-appointment-auditing-control-dialog/medical-appointment-auditing-control-dialog.component";
import { AuthService } from "src/app/services/auth.service";
import {
  ObservationDialogComponent,
  ObservationDialogEditResponse,
} from "../../dialogs/observation-dialog/observation-dialog.component";

@Component({
  selector: "app-medical-appointment-auditing-search",
  templateUrl: "./medical-appointment-auditing-search.component.html",
  styleUrls: ["./medical-appointment-auditing-search.component.css"],
})
export class MedicalAppointmentAuditingSearchComponent
  implements OnInit, OnDestroy {
  private readonly sessionColumnsKey =
    "medical-appointment-auditing-search.columns.v1";
  private readonly sessionSortKey = "medical-appointment-auditing-search.sort";
  private readonly sessionColumnWidthsKey =
    "medical-appointment-auditing-search.column-widths.v1";
  private hasStoredColumnsState = false;

  loadingRerport: boolean;
  loadingAction: boolean;
  searchFilters: SearchFilter[];
  widthTableExp: number;
  draggedColumn: string | null = null;
  sortActive: string = "";
  sortDirection: string = "";
  allItems: MedicalAppointmentAudintingSearchItem[] = [];
  columnFilters: { [key: string]: string } = {};
  columnWidths: { [key: string]: number } = {};
  displayedColumns: string[] = [
    "dateTime",
    "endHour",
    "stateName",
    "over",
    "patientLasNameFirstName",
    "age",
    "pid",
    "practice",
    "entity",
    "centerName",
    "isReferredToCallCenter",
    "isPatientDataValidated",
    "isDocumentationValidated",
    "isProcedureValidated",
    "isMedicalRecordValidated",

    "star",
  ];
  dataSource: MedicalAppointmentAudintingSearchItem[] = [];
  readonly columnsDefinition: Array<{ field: string; title: string }> = [
    { field: "dateTime", title: "Horario inicio" },
    { field: "endHour", title: "Horario fin" },
    { field: "stateName", title: "Estado" },
    { field: "over", title: "Sobreturno" },
    { field: "patientLasNameFirstName", title: "Paciente" },
    { field: "age", title: "Edad" },
    { field: "pid", title: "Pid" },
    { field: "practice", title: "Práctica" },
    { field: "entity", title: "Entidad" },
    { field: "centerName", title: "Centro" },
    { field: "isReferredToCallCenter", title: "Deriv. CC." },
    { field: "isPatientDataValidated", title: "Datos pac." },
    { field: "isDocumentationValidated", title: "Doc" },
    { field: "isProcedureValidated", title: "Prácticas" },
    { field: "isMedicalRecordValidated", title: "HCE" },
  ];
  @ViewChild("searchFilter", { static: false })
  searchFilter: SearchCompleteFilterComponent;
  @ViewChild("pager", { static: true }) pager: PagerControlComponent;
  @ViewChild("filters", { static: true })
  filters: MedicalAppointmentAuditingFilterComponent;
  canReservationReschedule: boolean = false;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private authservice: AuthService,
    private menuService: MenuService,
    private notificationToastService: NotificationToastService,
    private reservationRescheduleWizardService: ReservationRescheduleWizardService,
    private confirmDialogService: ConfirmDialogService,
    private medicalAppointmentAuditingService: MedicalAppointmentAuditingService,
    private reservationService: ReservationService
  ) {
    this.menuService.setMenuTitle("Turnos", "auditoría");
  }

  ngOnInit(): void {
    this.canReservationReschedule = this.authservice.canReservationReschedule();
    this.restoreColumnsOrder();
    this.normalizeDisplayedColumns();
    this.restoreSortState();
    this.restoreColumnWidths();
  }

  ngOnDestroy() {
    this.removeResizeListeners();
  }

  onStartSearch() {}

  get availableColumns(): Array<{ field: string; title: string }> {
    return this.columnsDefinition;
  }

  get orderedColumnsDefinition(): Array<{ field: string; title: string }> {
    const order = this.displayedColumns.filter((column) => column !== "star");
    const visibleColumns = new Set(order);
    const orderMap = new Map<string, number>(
      order.map((column, index) => [column, index])
    );

    return this.columnsDefinition
      .filter((column) => visibleColumns.has(column.field))
      .sort((a, b) => {
        const aIndex = orderMap.has(a.field) ? orderMap.get(a.field) : 999;
        const bIndex = orderMap.has(b.field) ? orderMap.get(b.field) : 999;
        return aIndex - bIndex;
      });
  }

  isColumnVisible(column: string): boolean {
    return this.displayedColumns.indexOf(column) >= 0;
  }

  setColumnVisibility(column: string, visible: boolean) {
    const dataColumns = this.displayedColumns.filter((item) => item !== "star");

    if (visible) {
      if (dataColumns.indexOf(column) < 0) {
        dataColumns.push(column);
      }
    } else {
      if (dataColumns.length <= 1) {
        return;
      }

      const removeIndex = dataColumns.indexOf(column);
      if (removeIndex >= 0) {
        dataColumns.splice(removeIndex, 1);
      }

      if (this.sortActive === column) {
        this.sortActive = "";
        this.sortDirection = "";
        sessionStorage.removeItem(this.sessionSortKey);
      }

      if (this.columnFilters[column]) {
        delete this.columnFilters[column];
      }
    }

    this.displayedColumns = [...dataColumns, "star"];
    this.saveColumnsOrder();
    this.refreshGrid();
  }

  showAllColumns() {
    const allColumns = this.availableColumns.map((column) => column.field);
    this.displayedColumns = [...allColumns, "star"];
    this.saveColumnsOrder();
    this.refreshGrid();
  }

  sortByColumn(column: string) {
    if (this.sortActive !== column) {
      this.sortAllData({ active: column, direction: "asc" });
      return;
    }

    if (this.sortDirection === "asc") {
      this.sortAllData({ active: column, direction: "desc" });
      return;
    }

    this.sortAllData({ active: "", direction: "" });
  }

  getSortIcon(column: string): string {
    if (this.sortActive !== column) {
      return "unfold_more";
    }

    return this.sortDirection === "asc" ? "arrow_upward" : "arrow_downward";
  }

  sortAllData(sortEvent: any) {
    if (!sortEvent || !sortEvent.active || sortEvent.direction === "") {
      this.sortActive = "";
      this.sortDirection = "";
      sessionStorage.removeItem(this.sessionSortKey);
      this.refreshGrid();
      return;
    }

    this.sortActive = sortEvent.active;
    this.sortDirection = sortEvent.direction;
    this.saveSortState();
    this.refreshGrid();
  }

  onColumnFilterInput(column: string, value: string) {
    this.columnFilters[column] = value;
    this.refreshGrid();
  }

  getColumnWidth(column: string): number | null {
    const width = this.columnWidths[column];
    return width && width > 0 ? width : null;
  }

  startResize(event: MouseEvent, column: string) {
    event.preventDefault();
    event.stopPropagation();

    const startX = event.clientX;
    const headerCell = (event.target as HTMLElement).closest("th");
    const measuredWidth = headerCell
      ? Math.round(headerCell.getBoundingClientRect().width)
      : 100;
    const startWidth = this.getColumnWidth(column) || Math.max(80, measuredWidth);

    const onMouseMove = (moveEvent: MouseEvent) => {
      const delta = moveEvent.clientX - startX;
      const nextWidth = Math.max(80, startWidth + delta);
      this.columnWidths = {
        ...this.columnWidths,
        [column]: nextWidth,
      };
    };

    const onMouseUp = () => {
      this.removeResizeListeners();
      this.saveColumnWidths();
    };

    (window as any).__medicalAppointmentAuditingResizeMove = onMouseMove;
    (window as any).__medicalAppointmentAuditingResizeUp = onMouseUp;
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  }

  onHeaderDragStart(event: DragEvent, column: string) {
    this.draggedColumn = column;

    if (event.dataTransfer) {
      event.dataTransfer.setData("text/plain", column);
      event.dataTransfer.effectAllowed = "move";
    }
  }

  onHeaderDragOver(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = "move";
    }
  }

  onHeaderDrop(event: DragEvent, targetColumn: string) {
    event.preventDefault();

    if (!this.draggedColumn || this.draggedColumn === targetColumn) {
      return;
    }

    const dataColumns = this.displayedColumns.filter((column) => column !== "star");
    const sourceIndex = dataColumns.indexOf(this.draggedColumn);
    const targetIndex = dataColumns.indexOf(targetColumn);

    if (sourceIndex < 0 || targetIndex < 0) {
      this.draggedColumn = null;
      return;
    }

    moveItemInArray(dataColumns, sourceIndex, targetIndex);
    this.displayedColumns = [...dataColumns, "star"];
    this.saveColumnsOrder();
    this.draggedColumn = null;
  }

  onHeaderDragEnd() {
    this.draggedColumn = null;
  }

  onTableResized(event: ResizedEvent): void {
    this.widthTableExp = event.newWidth - 40;
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = pagedItems ? [...pagedItems] : [];
  }

  onEndSearch(response: IFilterResponse<MedicalAppointmentAudintingSearchItem>) {
    this.searchFilters = response && response.searchFilters ? response.searchFilters : [];
    this.allItems = response && response.items ? [...response.items] : [];
    this.refreshGrid();
  }

  private getAllPosibleRescheduleReservation(
    medicalAppointmentId: number
  ): Promise<ReservationInfo> {
    const posible =
      this.reservationService.getAllPosibleRescheduleReservation(
        medicalAppointmentId
      );
    const confirmDialogService = this.confirmDialogService;
    const promise = new Promise<ReservationInfo>(function (resolve, reject) {
      posible
        .then((result: ReservationInfo) => {
          if (result.MedicalAppointmentIdsToCancel.length > 1) {
            confirmDialogService
              .confirm(
                "Reprogramación",
                "Existen turnos para el mismo día y Centro del Turno seleccionado, ¿desea reprogramarlos de forma conjunta?",
                "Sí",
                "No"
              )
              .subscribe((value) => {
                if (!value) {
                  for (
                    let i = result.ServiceReservations.length - 1;
                    i > -1;
                    i--
                  ) {
                    if (
                      result.ServiceReservations[i].MedicalAppointmentId !==
                      medicalAppointmentId
                    ) {
                      result.ServiceReservations.splice(i, 1);
                      result.MedicalAppointmentIdsToCancel.splice(i, 1);
                    }
                  }
                  resolve(result);
                } else {
                  resolve(result);
                }
              });
          } else {
            resolve(result);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  reservationRescheduling(reservationSearchItem: ReservationSearchItem) {
    this.getAllPosibleRescheduleReservation(
      reservationSearchItem.MedicalAppointmentId
    )
      .then((reservationInfo) => {
        this.reservationRescheduleWizardService.setReservationAndStartWizard(
          new Reservation(reservationInfo),
          "medical-appointment-auditing-search"
        );
        this.loadingAction = false;
      })
      .catch((err) => {
        this.notificationToastService.error(
          JSON.stringify(err.error),
          "Reprogramación"
        );
        this.loadingAction = false;
      });
  }

  async referredToCallCenter(item: MedicalAppointmentAudintingSearchItem) {
    const dialogRef = this.dialog.open(ObservationDialogComponent, {
      width: "50%",
      data: {
        text: "",
        textMenu: "Observaciones",
        noRequired: true,
      },
    });

    dialogRef
      .afterClosed()
      .subscribe(async (response: ObservationDialogEditResponse) => {
        if (response) {
          await this.medicalAppointmentAuditingService.audit(
            MedicalAppointmentAudintingType.derivadoCallCenter,
            item.MedicalAppointmentId,
            true,
            response.text
          );
          item.IsReferredToCallCenter = true;
        }
      });
  }

  openMedicalAppointmentObservationDialog(
    item: MedicalAppointmentAudintingSearchItem
  ): void {
    const dialogRef = this.dialog.open(
      MedicalAppointmenObservationDialogComponent,
      {
        width: "50%",
        data: {
          medicalAppointmentId: item.MedicalAppointmentId,
        },
      }
    );
  }

  openLogViewDialog(
    item: MedicalAppointmentAudintingSearchItem
  ): void {
    const dialogRef = this.dialog.open(LogViewDialogComponent, {
      width: "50%",
      data: item.MedicalAppointmentId,
    });
  }

  async revertReferredToCallCenter(
    item: MedicalAppointmentAudintingSearchItem
  ) {
    await this.medicalAppointmentAuditingService.audit(
      MedicalAppointmentAudintingType.derivadoCallCenter,
      item.MedicalAppointmentId,
      false
    );
    item.IsReferredToCallCenter = false;
  }

  control(item: MedicalAppointmentAudintingSearchItem) {
    const dialogRef = this.dialog.open(
      MedicalAppointmentAuditingControlDialogComponent,
      {
        width: "100vw", // Ocupa el ancho total de la pantalla
        height: "100vh", // Ocupa el alto total de la pantalla
        maxWidth: "100vw",
        maxHeight: "100vh",
        panelClass: "full-screen-dialog", // Clase CSS para más ajustes
        data: {
          appointment: item,
          canEditOthers: true,
        },
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
    });
  }

  applyFilter() {
    // this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  private saveColumnsOrder() {
    sessionStorage.setItem(this.sessionColumnsKey, JSON.stringify(this.displayedColumns));
  }

  private restoreColumnsOrder() {
    const stored = sessionStorage.getItem(this.sessionColumnsKey);
    if (!stored) {
      return;
    }

    try {
      const parsed: string[] = JSON.parse(stored);
      if (!parsed || !Array.isArray(parsed)) {
        return;
      }

      const allowed = new Set(this.availableColumns.map((column) => column.field));
      const parsedDataColumns = parsed
        .filter((column) => column !== "star")
        .filter((column, index, arr) => arr.indexOf(column) === index)
        .filter((column) => allowed.has(column));

      if (parsedDataColumns.length > 0) {
        this.displayedColumns = [...parsedDataColumns, "star"];
        this.hasStoredColumnsState = true;
      }
    } catch {
      sessionStorage.removeItem(this.sessionColumnsKey);
    }
  }

  private normalizeDisplayedColumns() {
    const expectedDataColumns = this.availableColumns.map((column) => column.field);
    const expectedSet = new Set(expectedDataColumns);
    const currentDataColumns = this.displayedColumns
      .filter((column) => column !== "star")
      .filter((column) => expectedSet.has(column));

    let normalizedDataColumns = [...currentDataColumns];

    if (!this.hasStoredColumnsState) {
      normalizedDataColumns = [...expectedDataColumns];
    }

    if (normalizedDataColumns.length === 0) {
      normalizedDataColumns = [...expectedDataColumns];
    }

    this.displayedColumns = [...normalizedDataColumns, "star"];
  }

  private saveSortState() {
    sessionStorage.setItem(
      this.sessionSortKey,
      JSON.stringify({ active: this.sortActive, direction: this.sortDirection })
    );
  }

  private restoreSortState() {
    const stored = sessionStorage.getItem(this.sessionSortKey);
    if (!stored) {
      return;
    }

    try {
      const parsed = JSON.parse(stored);
      if (parsed && parsed.active && parsed.direction) {
        this.sortActive = parsed.active;
        this.sortDirection = parsed.direction;
      }
    } catch {
      sessionStorage.removeItem(this.sessionSortKey);
    }
  }

  private saveColumnWidths() {
    sessionStorage.setItem(
      this.sessionColumnWidthsKey,
      JSON.stringify(this.columnWidths)
    );
  }

  private restoreColumnWidths() {
    const stored = sessionStorage.getItem(this.sessionColumnWidthsKey);
    if (!stored) {
      this.columnWidths = {};
      return;
    }

    try {
      const parsed = JSON.parse(stored);
      if (!parsed || typeof parsed !== "object") {
        return;
      }

      const validColumns = new Set(this.availableColumns.map((column) => column.field));

      const restored: { [key: string]: number } = {};
      Object.keys(parsed).forEach((column) => {
        if (!validColumns.has(column)) {
          return;
        }

        const width = Number(parsed[column]);
        if (!isNaN(width) && width >= 80 && width <= 500) {
          restored[column] = width;
        }
      });

      this.columnWidths = restored;
    } catch {
      sessionStorage.removeItem(this.sessionColumnWidthsKey);
      this.columnWidths = {};
    }
  }

  private sortItems(
    items: MedicalAppointmentAudintingSearchItem[],
    active: string,
    direction: string
  ): MedicalAppointmentAudintingSearchItem[] {
    return items.sort((a, b) => {
      const aValue = this.getSortableValue(a, active);
      const bValue = this.getSortableValue(b, active);

      if (aValue < bValue) {
        return direction === "asc" ? -1 : 1;
      }

      if (aValue > bValue) {
        return direction === "asc" ? 1 : -1;
      }

      return 0;
    });
  }

  private refreshGrid() {
    const currentPage =
      this.pager && this.pager.pager && this.pager.pager.currentPage
        ? this.pager.pager.currentPage
        : 1;

    let items = this.applyColumnFilters(this.allItems || []);

    if (this.sortActive && this.sortDirection) {
      items = this.sortItems([...items], this.sortActive, this.sortDirection);
    }

    this.pager.setItems(items);
    if (currentPage > 1) {
      this.pager.setPage(currentPage);
    }
  }

  private applyColumnFilters(
    items: MedicalAppointmentAudintingSearchItem[]
  ): MedicalAppointmentAudintingSearchItem[] {
    const filters = Object.keys(this.columnFilters || {}).filter(
      (key) => !!this.columnFilters[key] && this.columnFilters[key].trim() !== ""
    );

    if (filters.length === 0) {
      return [...items];
    }

    return items.filter((item) => {
      return filters.every((column) => {
        const filterValue = this.normalizeFilterValue(this.columnFilters[column]);
        const itemValue = this.normalizeFilterValue(this.getColumnFilterValue(item, column));
        return itemValue.indexOf(filterValue) >= 0;
      });
    });
  }

  private getSortableValue(
    item: MedicalAppointmentAudintingSearchItem,
    property: string
  ): any {
    if (!item) {
      return "";
    }

    return this.normalizeFilterValue(this.getColumnFilterValue(item, property));
  }

  private getColumnFilterValue(
    item: MedicalAppointmentAudintingSearchItem,
    column: string
  ): string {
    if (!item) {
      return "";
    }

    switch (column) {
      case "dateTime":
        return item.DateTime != null ? String(item.DateTime) : "";
      case "endHour":
        return item.EndHour != null ? String(item.EndHour) : "";
      case "stateName":
        return item.StateName != null ? String(item.StateName) : "";
      case "over":
        return item.IsOverMedicalAppointment != null
          ? String(item.IsOverMedicalAppointment)
          : "";
      case "patientLasNameFirstName":
        return item.PatientLasNameFirstName != null
          ? String(item.PatientLasNameFirstName)
          : "";
      case "age":
        return item.Year != null ? String(item.Year) : "";
      case "pid":
        return item.PatientId != null ? String(item.PatientId) : "";
      case "practice":
        return item.PrincipalPracticeName != null
          ? String(item.PrincipalPracticeName)
          : "";
      case "entity":
        return item.EntityName != null ? String(item.EntityName) : "";
      case "centerName":
        return item.CenterName != null ? String(item.CenterName) : "";
      case "isReferredToCallCenter":
        return item.IsReferredToCallCenter ? "si" : "no";
      case "isPatientDataValidated":
        return item.IsPatientDataValidated ? "si" : "no";
      case "isDocumentationValidated":
        return item.IsDocumentationValidated ? "si" : "no";
      case "isProcedureValidated":
        return item.IsProcedureValidated ? "si" : "no";
      case "isMedicalRecordValidated":
        return item.IsMedicalRecordValidated ? "si" : "no";
      default:
        return "";
    }
  }

  private normalizeFilterValue(value: string): string {
    const normalized = value ? String(value) : "";
    return normalized
      .toLocaleLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  private removeResizeListeners() {
    const onMouseMove = (window as any).__medicalAppointmentAuditingResizeMove;
    const onMouseUp = (window as any).__medicalAppointmentAuditingResizeUp;

    if (onMouseMove) {
      document.removeEventListener("mousemove", onMouseMove);
      (window as any).__medicalAppointmentAuditingResizeMove = null;
    }

    if (onMouseUp) {
      document.removeEventListener("mouseup", onMouseUp);
      (window as any).__medicalAppointmentAuditingResizeUp = null;
    }
  }

  async showReport() {
    try {
      this.loadingRerport = true;
      await this.filters.showReport();
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Reserva");
    } finally {
      this.loadingRerport = false;
    }
  }
}
